import type { ClientApplicationContext } from '@hc-frontend/core-context';
import { getClientApplicationContext } from '@hc-frontend/core-context';
import type { ResponseSnowPlow } from '@hc-frontend/third-party-snowplow';

import { snowplowTrackingRepositoryAdapterFactory } from '../../../adapters/snowplow-tracking-repository';
import { getDomainIdsFactory } from '../../../domain';

export function getUserIdClientSide(
  tracker: ResponseSnowPlow['tracker'],
): ClientApplicationContext['getDomainUserId'] {
  return async () => {
    const context = getClientApplicationContext(getUserIdClientSide);
    const useCase = getDomainIdsFactory({
      ...context,
      sessionProvider: snowplowTrackingRepositoryAdapterFactory(tracker),
    });

    const result = await useCase();

    return result.data.userId || '';
  };
}
